import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { LocalizationUtil } from '../../utils/localization.util';
import { ActionTypes as AppActionTypes } from '../actions/app.action';
import { ActionTypes as AccountActionTypes } from '../actions/my-account.action';
import { ActionTypes as ContentActionTypes } from '../actions/content.action';

@Injectable()
export class AppEffects {
    refresh$ = createEffect(() => 
        this.action$
            .pipe(
                ofType(AppActionTypes.Refresh),
                switchMap(() => {
                    this.localizationUtil.init();
                    return [
                        {type: AccountActionTypes.LoadProfile, payload: {reload: true}},
                        {type: ContentActionTypes.GetLabels, payload: {reload: true}},
                    ];
                })
            )
    );
    constructor(
        private action$: Actions,
        private localizationUtil: LocalizationUtil
    ) {}

}
